<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option value="0" label="未审批"></el-option>
                    <el-option value="1" label="已通过"></el-option>
                    <el-option value="2" label="未通过"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getCashOutListHandler" plain>查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData"
		 border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"
		 height="600" 
        :default-sort = "{prop: 'createTime', order: 'descending'}">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="agentName" label="代理商名称"  align="center"></el-table-column>
           <el-table-column  align="center"  label="佣金类型"  width="100px">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.applyType==0"  :content="scope.row.applyTypeName">
                        <p style="color:green"> {{scope.row.applyTypeName}}</p>
                    </el-tooltip>
                     <el-tooltip v-else  :content="scope.row.applyTypeName" >
                        <p style="color:brown"> {{scope.row.applyTypeName}}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="申请时间"  align="center" sortable></el-table-column>
            <el-table-column prop="priceRmb" label="提现金额（元）" align="center"></el-table-column>
            <el-table-column prop="feeRmb" label="提现手续费（元）" align="center"></el-table-column>
            <el-table-column prop="approveTime" label="审批时间" sortable align="center"></el-table-column>
            <el-table-column label="到账金额（元）" align="center">
                <template v-slot="scope" >
                    <span v-if="scope.row.state != '0'">{{scope.row.priceRmb - scope.row.feeRmb}}</span>
                </template>
            </el-table-column>
             <el-table-column prop="remark" label="审批备注" sortable align="center"></el-table-column>
            <el-table-column label="审批结果" align="center">
                <template v-slot="scope" >
                    <span v-if="scope.row.state=='2'" style="color: #8e8e8e">{{scope.row.stateName}}</span>
                    <span v-else-if="scope.row.state=='1'" style="color: green">{{scope.row.stateName}}</span>
                    <span v-else style="color: red">{{scope.row.stateName}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

        <el-dialog :append-to-body="true"  title="提现申请" :visible.sync="applyVisible"  width="400px" @close="cancelToApply" :close-on-click-modal="false">
            <p>提现金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入提现金额">
            </div>
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandler()">申 请</el-button>
        </el-dialog> 

    </div>
</template>
<script>
import {getCashOutList, applyCashOut, cashOutApprove} from '@/api/finance.js';
import common from '@/utils/common.js';
import {mapGetters } from "vuex";
export default {
    data() {
        return {
            searchForm: {
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            applyVisible: false,
            priceRmb: '',
            dataApprove:{
                id:'',
                state: 1,
            }
        }
    },
    methods: {
        getCashOutListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getCashOutList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        applyCashOutHandler(){
            if(Number(this.priceRmb) <= 0){
                this.$message.error('请输入提现金额');
                return;
            }
            let data = {"priceRmb":Number(this.priceRmb)};

            this.$confirm('确定要提现吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyCashOut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getCashOutListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    this.priceRmb = '';
                    this.applyVisible = false;
                })
            }).catch(() => {

            });
        },

        formatPrice(){
            this.priceRmb = this.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },

        cancelToApply(){
            this.priceRmb = '';
            this.applyVisible = false;
        },


        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getCashOutListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getCashOutListHandler();
        }         
    },
    created () {
        this.getCashOutListHandler();
    },
    computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        })
    },
}
</script>
<style  lang="less" scoped>
    .priceDiv{
        margin-top: 20px;
        margin-bottom:50px;
        display: flex;

        .priceIcon{
            display: inline-block;
            flex: 1;
            height:35px;
            width:50px;
            line-height:35px;
            font-size:24px;
            text-align: center;
            border-bottom:1px solid #000;
        }

        .priceRmbInput{
            line-height:35px;
            flex: 1;
            height:35px;
            font-size: 28px;
            outline:none;
            border: none;
            border-bottom: 1px solid #000;
        }

        input:-ms-input-placeholder {
            font-size: 14px;
        }

        input::-moz-input-placeholder {
            font-size: 14px;
        }
        input::-webkit-input-placeholder {
            font-size: 14px;
        }
        input:-moz-placeholder{font-size: 14px;}                 
        input::-moz-placeholder{font-size: 14px;}                
        input:-ms-input-placeholder{font-size: 14px;}   


    }

</style>